module.exports = __webpack_public_path__ + "img/kyzkzxt2.daafb951.jpg";